import moment from "moment";
import GlobalEvent from "@/common/Event";

export const authIDModal = (userInfo) => {
  const pathname = window.location.pathname.toLowerCase();
  const checkPathName =
    pathname.indexOf("mypage/auth") > -1 ||
    pathname.indexOf("auth-address") > -1 ||
    pathname.indexOf("withdraw") > -1 ||
    pathname.indexOf("deposit") > -1 ||
    pathname.indexOf("trade") > -1 ||
    pathname.indexOf("wow/") > -1 ||
    pathname.indexOf("token-swap") > -1 ||
    pathname.indexOf("hashpower") > -1;

  if (checkPathName) {
    const foreignYn = userInfo.foreignYn || "N"; // 외국인
    if (userInfo.dueDiligenceInfo) {
      const corpCode = userInfo.dueDiligenceInfo.corpCode || "C"; // wlf 거절 여부
      if (foreignYn == "Y" && corpCode && corpCode == "F") {
        // 외국인(개인)
        // console.log("authmodal-1111");
        GlobalEvent.$emit("restrictOrder", {
          modalName: "restrictOrder",
          show: true,
        });
        return false;
      }
      const sbStatus = userInfo.dueDiligenceInfo.sbStatus; // 신원인증 상태
      const wlfYn = userInfo.dueDiligenceInfo.wlfYn; // wlf 거절 여부

      // wlf 거절
      // if (true) {
      if (wlfYn === "Y") {
        // 신규
        if (sbStatus === "R") {
          // console.log("authmodal-2222");
          GlobalEvent.$emit("waiting");
          return false;
        }
        // 재인증
        if (sbStatus === "RE" || sbStatus === "E") {
          // console.log("authmodal-3333");
          GlobalEvent.$emit("rejectOrder");
          return false;
        }
        // 거절
        // if (sbStatus === "J") {
        //   GlobalEvent.$emit("wlfReject");
        //   return false;
        // }
      }

      // 신원인증 미인증
      if (
        sbStatus !== "E" &&
        sbStatus !== "RE" &&
        pathname !== "/mypage/auth" &&
        pathname.indexOf("token-swap") === -1
      ) {
        console.log("authmodal-4444");
        GlobalEvent.$emit("doAuthNoti");
        return false;
      }

      // 재이행주기 도래일 이후
      const reAuthDateformat = moment(
        userInfo.dueDiligenceInfo.reAuthDate
      ).format("YYYY-MM-DD");
      const regDateformat = moment(userInfo.dueDiligenceInfo.regDate).format(
        "YYYY-MM-DD"
      );
      if (reAuthDateformat < moment().format("YYYY-MM-DD")) {
        // 재이행주기
        if (sbStatus === "E") {
          // console.log("authmodal-5555");
          GlobalEvent.$emit("reAuthNoti");
          return false;
        }
        // 재인증
        if (regDateformat > reAuthDateformat && sbStatus === "RE") {
          // console.log("authmodal-6666");
          GlobalEvent.$emit("waiting");
          return false;
        }
      }
      return true;
    } else {
      console.log("11111");
      if (
        pathname !== "/mypage/auth" ||
        pathname.indexOf("/wow") === -1 ||
        pathname.indexOf("/token-swap") === -1
      ) {
        console.log("pathname", pathname);
        console.log("222");
        // console.log("authmodal-7777");
        GlobalEvent.$emit("doAuthNoti");
        return false;
      }
    }
  }
  return true;
};
